import { OnChangeParams } from 'baseui/select';
import { useMemo } from 'react';
import { PAYMENT_METHOD_OPTIONS } from '../../constants/app';
import { PaymentMethod } from '../../types/app';
import { EnhancedLabeledSelect } from '../ui/EnhancedLabeledSelect';

type Props = {
  selectedId?: PaymentMethod;
  onChangeId?: (id?: PaymentMethod) => void;
  isFilter?: boolean;
  label?: string;
  emptyOptionText?: string;
  showEmptyOption?: boolean;
  error?: React.ReactNode;
  onBlur?: () => void;
  inline?: boolean;
  clearable?: boolean;
  required?: boolean;
  disabled?: boolean;
  selectMaxWidth?: number;
};

function PaymentMethodSelect({
  selectedId,
  onChangeId,
  isFilter = false,
  label = 'Forma de pago:',
  emptyOptionText = 'Seleciona una forma de pago',
  showEmptyOption = false,
  error,
  onBlur,
  inline,
  clearable = false,
  required = false,
  disabled = false,
  selectMaxWidth,
}: Readonly<Props>) {
  const paymentMethodOptions = useMemo(() => {
    const coreOptions = PAYMENT_METHOD_OPTIONS;
    const options = showEmptyOption
      ? [
          {
            id: undefined,
            label: isFilter ? 'Todos' : emptyOptionText,
          },
          ...coreOptions,
        ]
      : coreOptions;
    return options;
  }, [isFilter, showEmptyOption, emptyOptionText]);

  const onSelectedChange = (params: OnChangeParams) => {
    if (params.option?.id) {
      onChangeId?.(params.option.id as PaymentMethod);
    } else {
      onChangeId?.(undefined);
    }
  };

  return (
    <EnhancedLabeledSelect
      label={label}
      options={paymentMethodOptions}
      value={showEmptyOption || selectedId !== undefined ? [{ id: selectedId }] : undefined}
      onChange={onSelectedChange}
      fullWidth
      onBlur={() => {
        onBlur?.();
      }}
      searchable
      inline={inline}
      inset={inline}
      error={error}
      required={required}
      clearable={clearable}
      placeholder={emptyOptionText}
      disabled={disabled}
      selectMaxWidth={selectMaxWidth}
    />
  );
}

export default PaymentMethodSelect;
